const evidence = {
    COMPOUND: {
        type: 'compound',
        genomateScoreAnatomyTitle: 'GDS Anatomy',
        genomateScoreAnatomySubtitle: 'Evidence for this compound',
        additionalEvidence: 'Additional scores',
        genomateScoreAnatomyDescription: 'What is',
        scoreName: 'gds'
    },
    TARGET: {
        type: 'target',
        genomateScoreAnatomyTitle: 'GTS Anatomy',
        genomateScoreAnatomySubtitle: 'Evidence for this target',
        additionalEvidence: 'Additional scores',
        genomateScoreAnatomyDescription: 'What is',
        scoreName: 'gts'
    },
    DRIVER: {
        type: 'driver',
        genomateScoreAnatomyTitle: 'GBS Anatomy',
        additionalEvidence: 'Additional scores',
        genomateScoreAnatomyDescription: 'What is',
        genomateScoreAnatomySubtitle: 'Evidence for this',
        genomateScoreAnatomySubtitles: {
            DRIVER: 'Evidence for this driver',
            BIOMARKER: 'Evidence for this biomarker',
            NON_CONFIRMED_DRIVER: 'Evidence for this conflicting driver',
            VUS: 'Evidence for this VUS',
            NON_DRIVER: 'Evidence for this non driver',
            VUS_IN_DRIVER: 'Evidence for this VUS in driver',
            GENOMIC_MARKER: 'Evidence for this genomic marker'
        },
        scoreName: 'gbs'
    },
    tabBar: {
        clinical: 'Clinical',
        preclinical: 'Preclinical',
        frequency: 'Frequency',
        insilico: 'In Silico'
    },
    evidenceList: 'Evidence list'
}

export default evidence
